import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";

type CategoryAndTagLookupType = {
  [key: string]: {
    category: string;
    tag: string | null;
  };
};

const categoryAndTagLookup: CategoryAndTagLookupType = {
  "Claim - cashback": {
    category: "claims",
    tag: "Free cashback",
  },
  "Claim - free product/service": {
    category: "claims",
    tag: "Claim item/service",
  },
  "Guarantee - Claim": {
    category: "claims",
    tag: "Extra guarantee",
  },
  "Guarantee - JL": {
    category: "offers",
    tag: "Extra guarantee",
  },
  "Half Price Install (Coupon)": {
    category: "offers",
    tag: "50% off install",
  },
  "Half Price Install (Coupon App only)": {
    category: "offers",
    tag: "50% off install",
  },
  "Half Price Install (PIM Service)": {
    category: "services",
    tag: "50% off install",
  },
  "Free Install & Recycling": {
    category: "services",
    tag: "Free service",
  },
  "Free Recycling": {
    category: "services",
    tag: "Free recycling",
  },
  "Free Installation": {
    category: "services",
    tag: "Free installation",
  },
  "Free Install/Recycling - D2C": {
    category: "services",
    tag: "Free service",
  },
  "Free Mattress Recycling": {
    category: "services",
    tag: "Free recycling",
  },
  "Free TV Recycling": {
    category: "services",
    tag: "Free recycling",
  },
  "Free TV Wall Mount Install": {
    category: "services",
    tag: "Free installation",
  },
  "Trade In - Coupon": {
    category: "offers",
    tag: "Trade in offer",
  },
  "Trade In - Coupon (App only)": {
    category: "offers",
    tag: "Trade in offer",
  },
  "Trade In - Claim": {
    category: "claims",
    tag: "Trade in offer",
  },
  "Trade In - Enhanced": {
    category: "offers",
    tag: "Trade in offer",
  },
  "Combination offer - £ off discounted item": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - £ off qualifying item": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - % off discounted item": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - % off qualifying item": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - 1 item free on qualifying item": {
    category: "offers",
    tag: "Free gift",
  },
  "Combination offer - 1 item free (message on free item)": {
    category: "offers",
    tag: "Free gift",
  },
  "Combination offer - Free product C when buy product A & B": {
    category: "offers",
    tag: "Buy 2, get 1 free",
  },
  "Combination offer - Get one item for a fixed price": {
    category: "offers",
    tag: "Combination offer",
  },
  "My JL Save (£)": {
    category: "offers",
    tag: "Member savings",
  },
  "My JL Save (%)": {
    category: "offers",
    tag: "Member savings",
  },
  "MyJL Additional Save (£)": {
    category: "offers",
    tag: "Member savings",
  },
  "MyJL Additional Save (%)": {
    category: "offers",
    tag: "Member savings",
  },
  "Spend Stretch- GWP ": {
    category: "offers",
    tag: "Multibuy offer",
  },
  "Spend Stretch- £ off ": {
    category: "offers",
    tag: "Multibuy offer",
  },
  "Tiered Spend Stretch": {
    category: "offers",
    tag: "Multibuy offer",
  },
  "Free next day delivery (Coupon)": {
    category: "offers",
    tag: "Free delivery",
  },
  "Combination offer - £ off discounted item (App Only)": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - £ off qualifying item (App Only)": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - % off discounted item (App Only)": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - % off qualifying item (App Only)": {
    category: "offers",
    tag: "Combination offer",
  },
  "Combination offer - 1 item free on qualifying item (App Only)": {
    category: "offers",
    tag: "Free gift",
  },
  "Combination offer - 1 item free (message on free item) (App Only)": {
    category: "offers",
    tag: "Free gift",
  },
  "Combination offer - Free product C when buy product A & B (App Only)": {
    category: "offers",
    tag: "Buy 2, get 1 free",
  },
  "Combination offer - Get one item for a fixed price (App Only)": {
    category: "offers",
    tag: "Discount offer",
  },
  "My JL Save (£) (App Only)": {
    category: "offers",
    tag: "Member savings",
  },
  "My JL Save (%) (App Only)": {
    category: "offers",
    tag: "Member savings",
  },
  "MyJL Additional Save (£) (App Only)": {
    category: "offers",
    tag: "Member savings",
  },
  "MyJL Additional Save (%) (App Only)": {
    category: "offers",
    tag: "Member savings",
  },
  "Spend Stretch- GWP (App Only)": {
    category: "offers",
    tag: "Multibuy offer",
  },
  "Spend Stretch- £ off (App Only)": {
    category: "offers",
    tag: "Multibuy offer",
  },
  "Tiered Spend Stretch (App Only)": {
    category: "offers",
    tag: "Multibuy offer",
  },
  "Free next day delivery (Coupon) (App Only)": {
    category: "offers",
    tag: "Free delivery",
  },
  "Free Gift in bundle": {
    category: "offers",
    tag: "Gift included",
  },
  "Free Item in bundle": {
    category: "offers",
    tag: "Gift included",
  },
  "Ad hoc promotion": {
    category: "offers",
    tag: "Offer available",
  },
};

type messageWithCategoryAndType = (
  | NonPromotionalMessage
  | PromotionalMessage
) & { category: string; tag: string | null };

type CategoriseMessagesResponse = messageWithCategoryAndType[];

const isPromotionalMessage = (
  message: NonPromotionalMessage | PromotionalMessage,
): message is PromotionalMessage => {
  return (message as PromotionalMessage).promotionGroup !== undefined;
};

export const categoriseMessages = (
  messages: (NonPromotionalMessage | PromotionalMessage)[],
): CategoriseMessagesResponse => {
  return messages.map((message) => {
    if (isPromotionalMessage(message)) {
      const categorisation =
        categoryAndTagLookup[
          message.promotionType as keyof CategoryAndTagLookupType
        ];

      if (!categorisation) {
        return Object.assign(
          { category: "offers", tag: "Offer available" },
          message,
        );
      } else {
        const { category, tag } = categorisation;
        return Object.assign({ category, tag }, message);
      }
    } else {
      return Object.assign(
        { category: "offers", tag: "Offer available" },
        message,
      );
    }
  });
};

type StringFormatTagsResponse = string[];

const numberTags = (messages: messageWithCategoryAndType[]) => {
  const numberedTagsObj = messages.reduce(
    (acc: Record<string, number>, message: messageWithCategoryAndType) => {
      const { tag } = message;
      if (tag) {
        if (acc[tag]) {
          acc[tag] = (acc[tag] as number) + 1;
        } else {
          acc[tag] = 1;
        }
      }
      return acc;
    },
    {},
  );

  return numberedTagsObj;
};

const stringFormatTags = (
  numberedTagsObj: Record<string, number>,
  category: "offers" | "claims",
): StringFormatTagsResponse => {
  const tagWithQuantityArray = Object.entries(numberedTagsObj);

  const stringFormatTag = (tagAndNumber: [string, number]) => {
    if (tagAndNumber[1] === 1) {
      return `${tagAndNumber[0]}`;
    } else {
      return `${tagAndNumber[0]} (${tagAndNumber[1]})`;
    }
  };

  if (tagWithQuantityArray.length > 2) {
    const totalRemainingMessages = tagWithQuantityArray
      .slice(1)
      .reduce((acc, tagWithQuantity) => acc + tagWithQuantity[1], 0);

    return [
      stringFormatTag(tagWithQuantityArray[0] as [string, number]),
      `+${totalRemainingMessages} more ${category}`,
    ];
  } else {
    return tagWithQuantityArray.map((tagAndNumber) =>
      stringFormatTag(tagAndNumber),
    );
  }
};

export const formatTagsForDisplay = (
  messages: messageWithCategoryAndType[],
) => {
  const offerMessages = messages.filter(
    (message) =>
      message.category === "offers" || message.category === "services",
  );
  const claimMessages = messages.filter(
    (message) => message.category === "claims",
  );

  const numberedOfferTags = numberTags(offerMessages);
  const numberedClaimTags = numberTags(claimMessages);

  const formattedTags = {
    offers: stringFormatTags(numberedOfferTags, "offers"),
    claims: stringFormatTags(numberedClaimTags, "claims"),
  };

  return formattedTags;
};
